export class AIReportContainer extends HTMLElement {
    $thumbsUpDownRater = null;

    constructor()
    {
        super();
    }

    connectedCallback()
    {
        this.init();
    }

    init()
    {
        this.initEventHandlers();
        this.updateReportsViewed();
    }

    initEventHandlers()
    {
            const mutationObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.addedNodes.length > 0) {
                        const addedNode = mutation.addedNodes[0];
                        if (addedNode.nodeName === 'svg') {
                            addedNode.addEventListener('click', () => this.updateReportsViewed);
                        }
                    }
                });
            });
        const reportContainer = this.querySelector('.reports');
        const reportLinks = reportContainer.querySelectorAll('td.download-link a');
        this.updateReportsViewed.bind(this);
        reportLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
                this.updateReportsViewed(event);
            });
            // mutationObserver.observe(link, {
            //     childList: true,
            //     subtree: false,
            // });
        });

    }

    updateReportsViewed(event)
    {
        // first update the row of dicom clicked, to mark it as viewed
        if (event) {
            const target = event.target;
            const targetRow = target.closest('tr');
            targetRow.classList.add('viewed');
        }

        // now count all the viewed rows in the table
        const allRows = this.querySelectorAll('tr.viewed');
        const allRowsCount = allRows.length;

        const beginViewedCount = this.dataset.report_count;
        const endViewedCount = beginViewedCount - allRowsCount;

        // now update the report count in the header
        const reportCountAmount = this.querySelector('.report-count-amount');
        if (endViewedCount > 0) {
            reportCountAmount.textContent = endViewedCount;
        } else {
            reportCountAmount.style.display = 'none';
        }
    }
}

customElements.define('ai-report-container', AIReportContainer);